export enum AlignmentType {
  left = 1,
  center = 2,
  right = 3,
}

export const AlignmentTypeName = {
  [AlignmentType.left]: 'Left',
  [AlignmentType.center]: 'Center',
  [AlignmentType.right]: 'Right',
};
